module.exports = __webpack_public_path__ + "img/white-error.f8ac6d5c.svg";